import React from "react";
import { useDispatch } from "react-redux";
import { fetchAllJobs, HighTolow, lowToHigh, searchFilter } from "../../features/FetchAllJobs/FetchAllJobsSlice";

const FilterSearchSort = () => {
  const dispatch = useDispatch();

  const handleSort = (e) =>{
    const value = e.target.value
    if (value === 'Salary (Low to High)') {
      dispatch(lowToHigh()) 
    }
    if (value === 'Salary (High to Low)') {
      dispatch(HighTolow()) 
    }
    if(value === 'Default'){
      dispatch(fetchAllJobs())
    }
  }

  const handleSearch = (e) =>{
    const query = e.target.value.toLowerCase()
    dispatch(searchFilter(query)) 
  }

  return (
    <div className="flex gap-4">
      <div className="search-field group flex-1">
        <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
        <input
        onChange={handleSearch}
          type="text"
          placeholder="Search Job"
          className="search-input"
          id="lws-searchJob"
        />
      </div>
      <select onChange={handleSort} id="lws-sort" name="sort" autoComplete="sort" className="flex-1">
        <option>Default</option>
        <option>Salary (Low to High)</option>
        <option>Salary (High to Low)</option>
      </select>
    </div>
  );
};

export default FilterSearchSort;
